import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { ZoneEffects, zoneReducers } from ".";

@NgModule({
    imports: [StoreModule.forFeature("chzone", zoneReducers), EffectsModule.forFeature([ZoneEffects])],
    providers: [ZoneEffects],
})
export class ZoneStoreModule {}
